import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import styles from "./index.module.scss";
import ProductDelivery from "./deliveryNew";
import Button from "/components/common/button";
import { showPopup } from "../../../../redux/action-creaters/popup";
import { popupTypes } from "../../../../redux/reducers/popupReducer";

export default function Bottom({ video }) {
  const { product } = useSelector((state) => state.product);

  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);

  const tabs = useMemo(() => {
    if (user.IS_MANAGER || user.IS_ADMIN) {
      return {
        description: "description",
        delivery: "delivery",
      };
    }
    return {
      description: "description",
    };
  }, [user]);

  const tabsNames = {
    [tabs.description]: "Описание",
    [tabs.delivery]: "Наличие и доставка",
  };

  const [currentTab, setTab] = useState(tabs.description);

  const router = useRouter();
  useEffect(() => {
    if (router.query.review) {
      dispatch(
        showPopup(popupTypes.addReview, {
          id: product.ID,
        }),
      );
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (typeof window === "undefined") {
        return;
      }
      Object.values(tabs).forEach((tab) => {
        if (window.location.hash === `#${tab}`) {
          const section = document.getElementById(tab);
          section.click();
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }, 0);
  }, []);

  const videosFormated = useMemo(() => {
    if (video) {
      let videos = video;
      if (!Array.isArray(videos)) {
        videos = [videos];
      }

      return videos
        .map((video) => {
          if (video.includes("vk.com")) {
            return {
              thumb:
                "https://downloadr2.apkmirror.com/wp-content/uploads/2022/12/89/6391a81ca2013.png",
              full: video,
              isVideo: true,
            };
          }
          if (video.includes("rutube.ru")) {
            let full = video;
            if (full.includes("/video/")) {
              const fullItems = full.split("/").filter((item) => item);
              full = `https://rutube.ru/play/embed/${fullItems[fullItems.length - 1]}/`;
            }
            return {
              thumb:
                "https://cs13.pikabu.ru/post_img/big/2023/06/11/11/1686509294231898515.png",
              full,
              isVideo: true,
            };
          }
          let videoCode = video.match(/[?&]v=([^&]*)/);
          if (!videoCode || !videoCode[1]) {
            videoCode = video.match(/be[/]*(.+)/);
          }
          if (videoCode && videoCode[1]) {
            return {
              thumb: `https://img.youtube.com/vi/${videoCode[1]}/default.jpg`,
              full: `https://www.youtube.com/embed/${videoCode[1]}?rel=0&amp;autoplay=1`,
              isVideo: true,
            };
          }
          return null;
        })
        .filter((video) => video);
    }
    return [];
  }, [video]);

  return (
    <div className={clsx(styles.Info)}>
      <div className={styles.Sections}>
        {Object.values(tabs).map((tab) => (
          <span
            onClick={() => {
              setTab(tab);
            }}
            key={tab}
            id={tab}
            className={clsx(currentTab === tab && styles.Selected)}
          >
            {tabsNames[tab]}
            {tab === tabs.reviews && product.REVIEWS > 0
              ? ` (${product.REVIEWS})`
              : ""}
            {tab === tabs.questions && product.QUESTIONS > 0
              ? ` (${product.QUESTIONS})`
              : ""}
          </span>
        ))}
      </div>

      {currentTab === tabs.description && (
        <div className={styles.Description}>
          {product.DETAIL_TEXT ? (
            <>
              <div className={"text"}>
                <div
                  itemProp="description"
                  dangerouslySetInnerHTML={{ __html: product.DETAIL_TEXT }}
                ></div>
              </div>
            </>
          ) : (
            <div>
              <p>
                Нет описания. Если у вас появились вопросы по товару - закажите
                обратный звонок:
              </p>
              <div>
                <Button
                  customStyles={styles.FormButton}
                  onClick={() => dispatch(showPopup(popupTypes.backCall))}
                  label={"Заказать звонок"}
                />
              </div>
            </div>
          )}
          {videosFormated.length > 0 && (
            <div>
              {[videosFormated[0]].map((video) => (
                // eslint-disable-next-line react/jsx-key
                <iframe
                  src={video?.full}
                  frameBorder={0}
                  allowFullScreen="allowfullscreen"
                ></iframe>
              ))}
            </div>
          )}
        </div>
      )}

      {currentTab === tabs.delivery && <ProductDelivery product={product} />}
    </div>
  );
}
